<template>
  <div class="row">
    <div class="col-md-12">
      <SelectsV2
        v-if="enableSelect == 1"
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :activeSelectProfissionais="false"
        :activeOptionTodos="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      />
      <SelectsV2
        v-if="enableSelect == 2"
        :activeSelectEquipes="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      />
    </div>
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs"
        v-model="tabsActive"
      >
        <b-tab title="Lista" active>
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>

          <div>
            <div class="info-table">
              <div class="info-table-item"></div>
              <div class="info-table-item">
                <download-files
                  :callback-pdf="generatePdf"
                  :data="displayedCadastros"
                  :fields="dataFields"
                  name="Cidadãos-duplicados"
                >
                </download-files>
              </div>
            </div>
            <tabela-cadastros
              ref="table"
              :cadastros="displayedCadastros"
              :loading="loading"
              @filterSearch="filterSearch($event)"
            ></tabela-cadastros>
          </div>
        </b-tab>
        <b-tab title="Resultado">
          <template v-slot:title>
            <i class="icofont-mathematical-alt-1"></i> Resultado
          </template>
          <div class="row">
            <div class="col-md-12">
              <tabela-resultado
                :loading="loading"
                :municipio="parseInt(valoresResultadoMunicipio)"
                :equipe="parseInt(valoresResultadoEquipe)"
              />
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import * as Functions from './functions.js'
import utils from '@/mixins/utils.js'
import TabelaCadastros from './TabelaCadastros.vue'
import TitleTag from '@/components/TitleTag.vue'
import SelectsV2 from '@/components/utils/SelectsV2.vue'
import TabelaResultado from './TabelaResultado.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'

export default {
  name: 'CidadaosDuplicadosPorEquipeAcs',
  components: {
    TabelaCadastros,
    SelectsV2,
    TabelaResultado,
    TitleTag,
    DownloadFiles,
  },
  mixins: [utils],
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  data() {
    return {
      enableSelect: '',
      tabsActive: 0,
      equipe: '',
      micro_area: '',
      cadastros: [],
      loading: false,
      situacaoOptions: [
        { label: 'SEM CPF E CNS', value: 'sem-cpf-e-cns' },
        { label: 'COM CPF E SEM CNS', value: 'com-cpf-e-sem-cns' },
        { label: 'COM CNS SEM CPF', value: 'com-cns-e-sem-cpf' },
        { label: 'TODOS', value: 'todos' },
      ],
      situacao: '',
      cadastrosOriginais: [],
      tabelaResultado: [],
      valoresResultadoMunicipio: 0,
      valoresResultadoEquipe: 0,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  methods: {
    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Manipula a alteração da equipe selecionada.
     *
     * @param {Object} event Equipe selecionada
     */
    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }

      this.cadastros = []
      this.valoresResultadoEquipe = 0

      const equipeNuIne = this.tabelaResultados.find(
        (el) => el.nu_ine === event.ine_esf_eap
      )
      if (equipeNuIne != undefined) {
        this.valoresResultadoEquipe = equipeNuIne.total_duplicados
      }
      this.micro_area = null
      this.tabsActive = 0
      this.equipe = event
      this.situacao = { label: 'COM CNS SEM CPF', value: 'com-cns-e-sem-cpf' }
      try {
        this.loading = true
        const response = await Functions.getDadosPorEquipe(
          this.$store.state.cod_ibge,
          this.equipe.ine_esf_eap
        )
        if (response) {
          this.cadastros = []
          this.cadastrosOriginais = response
          this.cadastros = response
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Manipula a alteração da microárea selecionada.
     *
     * @param {Object} event Microárea selecionada
     */
    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event == null) {
        this.cadastros = []
        await this.onChangeEquipe(this.equipe)
        return
      }
      this.tabsActive = 0
      this.micro_area = event.micro_area
      try {
        this.loading = true
        this.situacao = { label: 'COM CNS SEM CPF', value: 'com-cns-e-sem-cpf' }
        const response = await Functions.getDadosPorMicroArea(
          this.$store.state.cod_ibge,
          this.equipe.ine_esf_eap,
          this.micro_area
        )
        if (response) {
          this.cadastros = []
          this.cadastrosOriginais = response
          this.cadastros = response
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Busca os dados do resultado
     */
    async buscarDadosResultado() {
      const response = await this.$api.get(
        `app/cidadaos-duplicados/${this.$store.state.cod_ibge}/resultado`
      )
      this.tabelaResultados = response.data
      const municipio = this.tabelaResultados.reduce(
        (accumulator, currentObject) => {
          return accumulator + Number(currentObject.total_duplicados)
        },
        0
      )
      this.valoresResultadoMunicipio = municipio
    },

    /**
     * Gera o relatório em PDF.
     */
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.micro_area
      )
    },

    /**
     * Inicializa os dados
     */
    async init() {
      try {
        await this.buscarDadosResultado()

        // Enfermeiro, médico ...
        if (this.enableSelect == 2) {
          let nu_ine_profissional =
            this.$store.state.id_funcao == 8 ||
            this.$store.state.id_funcao == 14 ||
            this.$store.state.id_funcao == 15
              ? this.$store.state.nu_ine_vinculada
              : this.$store.state.nu_ine

          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == nu_ine_profissional
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
          }
          await this.onChangeEquipe(this.equipe)
        }
        // ACS
        if (this.enableSelect == 3) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
          }
          // this.micro_area = this.$store.state.micro_area
          await this.onChangeEquipe(this.equipe)
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.enableSelect = this.enableSelects()
    this.init()
  },
}
</script>

<style></style>
